import http from '@/plugins/api'
import {
  startLoading
} from '@/plugins/loading'
import * as types from './types'

export default {
  // setSelectedTeamMemberId({
  //   commit,
  //   state
  // }, teamMember) {
  //   commit('SET_MEMBER_ID', teamMember)
  // },
  async getMemberId({
    commit,
    state,
    dispatch
  }, id) {
    const r = await startLoading(dispatch, 'getTeamMemberIds', () =>
      http.get(`TeamQuery/GetTechnicianIds/?id=${id}`)
    )
    commit(types.SET_MEMBER_ROLE, r.data)
    // return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/hangfire/actions.js